import Axios from '../axios.js'

/**
 * 消缺接口
 */
export default {
	/**
	 * 添加或更新消缺检查项
	 * @param {String} pkid 消缺主键
	 * @param {String} name 消缺名称
	 * @param {String} valueType 数据类型  
	 * @param {String} defectType 
	 * @param {String} harm 危害
	 * @param {String} proposal 建议
	 * @param {String} typeCode 设备定义树
	 * @param {String} priority 缺陷等级 Emergent: '紧急',High: '高',Standard: '标准',Low: '低'
	 */
	saveDefect: (pkid, name, defectType, valueType, harm, proposal, priority, typeCode, success, failure) => {
		Axios.post('/workDefect/saveDefect.do', {
			pkid,
			name,
			defectType,
			valueType,
			harm,
			proposal,
			priority,
			typeCode,
		}, success, failure)
	},
	/**
	 * 删除消缺检查项
	 * @param {String} pkid
	 */
	deleteDefect: (pkid, success, failure) => {
		Axios.post('/workDefect/deleteDefect.do', {
			pkid
		}, success, failure)
	},
	/**
	 * 查询台账设备模板下消缺检查项列表
	 * @param {String} typeCode
	 */
	findDefectListByTypeCode: (typeCode, success, failure) => {
		Axios.get('/workDefect/findDefectListByTypeCode.do', {
			typeCode,
		}, success, failure)
	},
	/**
	 * 查询台账设备下消缺检查项列表
	 * @param {String} archivesIds 台账设备ids
	 */
	findDefectListByArchivesId: (archivesIds, success, failure) => {
		Axios.get('/workDefect/findDefectListByArchivesId.do', {
			archivesIds
		}, success, failure)
	}
}